import {
  parseDate
} from "./chunk-ERRQGV7D.mjs";

// src/date/month.ts
var startOfMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
};
var endOfMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
};
var daysInMonth = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
};

export {
  startOfMonth,
  endOfMonth,
  daysInMonth
};
//# sourceMappingURL=chunk-FX2F6Q2U.mjs.map